import moduleName from '../moduleName';

export default {
  RETRIEVE_API_DATAS: `${moduleName}/retrieveApiDatas`,
  GET_AUTHORS: `${moduleName}/getAuthors`,
};
